import http from '../http'
import {SUBSCRIPTION_URL} from "@/services/endpoints";

export function getSubscriptionPackageList() {
    return http.request({
        url: SUBSCRIPTION_URL + '/package',
        method: 'get'
    })
}
